/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import Markdown from 'markdown-to-jsx';

import { jsx } from '@atlaskit/css';
import { Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { AIDisclaimer, AIFeedbackComponent } from '@atlassian/ai-components';

type Props = {
	contentId: string;
	text?: string;
	showFooter?: boolean;
};

export const AISnippetContent = ({ text, contentId, showFooter = true }: Props) => {
	return (
		<Stack space="space.100">
			<Text size="small">
				<Markdown>{text || ''}</Markdown>
			</Text>
			{showFooter && text && (
				<Inline space="space.100">
					<AIDisclaimer />
					<AIFeedbackComponent contentId={contentId} />
				</Inline>
			)}
		</Stack>
	);
};
